import { notification } from 'antd';
import logger from './logger';

/**
 * Centralized error handler
 */
export const handleApiError = (error, customMessage = null) => {
  logger.error('API Error:', error);
  
  const errorMessage = customMessage || 
    error?.response?.data?.message || 
    error?.message || 
    'Something went wrong. Please try again.';
  
  notification.error({
    message: 'Error',
    description: errorMessage,
    placement: 'topRight',
  });
};

export const handleApiSuccess = (message = 'Operation completed successfully') => {
  notification.success({
    message: 'Success',
    description: message,
    placement: 'topRight',
  });
};

export const handleApiInfo = (message) => {
  notification.info({
    message: 'Info',
    description: message,
    placement: 'topRight',
  });
};

export default handleApiError;

